import {settlementService} from "@/common/api.service"
import loading from "../../components/custom/loading.vue";

const initialStates = {
    status: 'loading',
    form_data: {
        id: '',
        full_name: '',
        amount: '',
        wage: '',
        website_address: '',
        created_at: '',
        updated_at: '',
        psp: '',
        sheba_number: '',
        gateway_id: '',
        gateway_farsi_name: '',
        status: '',
        tracking_code: '',
        description: ''
    },
    admin_phones: {
        payload: [
            {
                full_name: null,
                phone: null,
            },
        ],
        send_notification_status: false
    },
    files: {}
}

const mutations = {
    loading(state) {
        state.status = 'loading'
    },
    success(state, form_data) {
        state.status = 'success'
        state.form_data = form_data
    },
    fetchFiles(state, files) {
        state.status = 'success'
        state.files = files
    },
    setAdminPhone(state, data) {
        state.status = 'success'
        if (Object.keys(data).length > 0)
            state.admin_phones = data
    }
}

const getters = {
    status: ({status}) => status,
    admin_phones: ({admin_phones}) => admin_phones,
    form_data: ({form_data}) => form_data,
    files: ({files}) => files
}

const actions = {
    find({commit}, hashid) {
        commit('loading')

        return settlementService.find(hashid).then(response => {
            commit('success', response.data.data)
        })
    },
    adminFind({commit} , hashid){
        commit("loading")

        return settlementService.adminFind(hashid).then(({ data: { data : adminFindData } }) => {
            commit('success', adminFindData);
        });
    },
    fetchFiles({commit}) {
        commit('loading')

        return settlementService.fetchFiles().then(response => {
            commit('fetchFiles', response.data.data)
        })
    },

    requestSettlementScript({commit}, type) {
        commit('loading')
        return settlementService.requestSettlementScript(type);
    },
    fetchAdminPhones({commit}) {
        commit('loading')
        return settlementService.fetchAdminPhones().then(({data}) => {
            commit('setAdminPhone', data.data)
        })
    },
    createAdminPhone({commit, state}, payload) {
        commit('loading')
        return settlementService.createAdminPhone(payload).then(() => {
            state.status = 'success'
        }).catch(() => {
            state.status = 'success'
        })
    }
}


export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}